import axiosInstance from '../Api/axiosInstance';

// Get all features
export const getFeatures = () => {
	return axiosInstance.get('/features');
};

// Get features by plan
export const getFeaturesByPlan = (planId) =>
	axiosInstance.get(`/features/plan/${planId}`);

// Get feature limits for a specific plan
export const getFeatureLimitsForPlan = (planId) =>
	axiosInstance.get(`/features/limits/${planId}`);

// Get a single feature by ID
export const getFeature = (id) => axiosInstance.get(`/features/${id}`);

// Create a new feature
export const createFeature = (featureData) =>
	axiosInstance.post('/features', featureData);

// Update an existing feature by ID
export const updateFeature = (id, featureData) =>
	axiosInstance.put(`/features/${id}`, featureData);

// Update plan limit for a feature
export const updatePlanLimit = (featureId, planId, limitData) =>
	axiosInstance.put(`/features/${featureId}/plan/${planId}`, limitData);

// Remove plan limit from a feature
export const removePlanLimit = (featureId, planId) =>
	axiosInstance.delete(`/features/${featureId}/plan/${planId}`);

// Delete a feature by ID
export const deleteFeature = (id) => axiosInstance.delete(`/features/${id}`);
